import { render } from "./SelectLotProduct.vue?vue&type=template&id=28092508"
import script from "./SelectLotProduct.vue?vue&type=script&lang=js"
export * from "./SelectLotProduct.vue?vue&type=script&lang=js"
script.render = render

export default script